import { configureStore } from '@reduxjs/toolkit';

import { authReducer } from './auth/reducer';
import { configsReducer } from './configs';
import { territoryDataReducer } from './countries';
import { documentSigningReducer } from './documentSigning';
import { unauthorizedSessionMiddleware } from './middleware/unauthorizedSessionMiddleware';
import { operationDataReducer } from './operation';
import { uiReducer } from './ui';
import { userDataReducer } from './user-data';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    configs: configsReducer,
    ui: uiReducer,
    userData: userDataReducer,
    operationData: operationDataReducer,
    territoryData: territoryDataReducer,
    documentSigning: documentSigningReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(unauthorizedSessionMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
